module.exports = __webpack_public_path__ + "img/存储服务器.677b019b.png";